export const Budgets = {
  scenario: {
    list: {
      title: 'Liste des scénarios budgets',
      culumn: {
        etat: 'Etat',
        code: 'Code',
        name: 'Nom',
        type: 'Type',
        period: 'Période',
        user: 'User',
        date_modif: 'Date de modification',
      },
    },
    fiche: {
      titleNew: "Création d'un nouveau scénario",
      editTitle: "Fiche d'un scenario {{code}}",
      title_code_list: 'Liste des codes natures',
      title_category_list: 'Liste des codes catégories',
      code_natureAll_placehoder: '- Tous les Codes Nature -',
      code_categoryAll_placehoder: '- Tous les Codes Catégories -',
      champs: {
        etat: 'Etat',
        code: 'Code',
        descri: 'Description',
        caracteristic: 'Caractéristiques',
        annee: 'Année',
        type: 'Type séléction',
        type_code: 'Type code',
        periode: 'Periode',
        month: 'Mois de Début',
        filtre_code: 'Filtre sur code',
      },
      message_validation:
        'Les conditions ont été modifiées. Les périodes vont être supprimées. Désirez-vous continuer ',
    },
    visualise: {
      title: 'Visualisation du scénario',
      type_placeholder: '- Type -',
      period_placeholder: '- Période -',
      code_nature_placehoder: '- Code Nature -',
      applique: 'Appliquer',
      action: {
        import_annuel: 'Importer données années précédentes',
        import: 'Importer Excel',
        action: 'Action',
        recherche: 'Rechercher par an',
      },
      modal_import: {
        title: 'Importer données années précédentes',
        annee: 'Année',
      },
    },
  },
  analyste: {
    title: 'Analyse Budget',
    titleDrawer: 'Scénario: Budget {{year}} - {{ name }} {{label}} {{year}}',
    devise: 'Devise',
    scenario: '- Scénario -',
    total_treso: 'Total Trésorerie',
    total_depense: 'Total Dépenses',
    total_recette: 'Total Récette',
    culumn: {
      nature: 'Nature',
      label: 'Libelle',
      devise: 'Devise',
      montant_bud: 'Montant budget',
      montant_realiser: 'Montant réalisé',
      montant_prev: 'Montant prévisions',
      avancement_realiser: 'Avancement réalisé',
      avancement_realiserPrev: 'Avancement réalisé et prévisions',
    },
  },
}

